var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "permission",
          rawName: "v-permission",
          value: _vm.PERMISSIONS.POLICY_MANAGEMENT,
          expression: "PERMISSIONS.POLICY_MANAGEMENT",
        },
      ],
      staticClass: "animated fadeIn",
    },
    [
      _c(
        "b-tabs",
        {
          staticClass: "body-bg-color",
          staticStyle: {
            "border-left": "0",
            "border-right": "0",
            "border-top": "0",
          },
        },
        [
          _c(
            "b-tab",
            {
              ref: "policies",
              staticClass: "body-bg-color overview-chart",
              staticStyle: {
                "border-left": "0",
                "border-right": "0",
                "border-top": "0",
              },
              attrs: { active: "" },
              on: {
                click: function ($event) {
                  return _vm.routeTo()
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-list-alt" }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("message.policies")) + "\n        "
                      ),
                      _c("b-badge", { attrs: { variant: "tab-total" } }, [
                        _vm._v(_vm._s(_vm.totalPolicies)),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("policy-list", {
                on: {
                  total: function ($event) {
                    _vm.totalPolicies = $event
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "b-tab",
            {
              ref: "licensegroups",
              on: {
                click: function ($event) {
                  return _vm.routeTo("licenseGroups")
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fa fa-balance-scale" }),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("message.license_groups")) +
                          "\n        "
                      ),
                      _c("b-badge", { attrs: { variant: "tab-total" } }, [
                        _vm._v(_vm._s(_vm.totalLicenseGroups)),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("license-group-list", {
                on: {
                  total: function ($event) {
                    _vm.totalLicenseGroups = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }